import { Env } from '@/shared/config/environment';
import { HttpClient } from '@/shared/lib/http-client';

export const confirmPetsContract = async (data) => {
  const response = await HttpClient.post(`${Env.server.mode}/insurance/pets/contract/confirm`, data);

  return response.data;
};
